<script lang="ts">
  import {accessLink} from 'Store/InvestorFlowStore';
  import IframeQuestionFlow from './IframedQuestionFlow.svelte';
</script>

<div
  data-testid="question-flow"
  class="question-flow-container"
  class:message-container={!$accessLink}
>
  {#if $accessLink}
    <IframeQuestionFlow />
  {:else}
    <div data-testid="question-flow-email" class="email-message title-wl-color">
      Please continue using the link you received in an email
    </div>
  {/if}
</div>

<style>
  .question-flow-container {
    height: 100%;
  }

  .message-container {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .email-message {
    font-size: 1.5rem;
  }
</style>
